import LvMessageBox from "./LvMessageBox.vue";
export { default as LvMessageBox } from "./LvMessageBox.vue";
export * from "./model";
export var MessageBox;
(function (MessageBox) {
    async function prompt(options) {
        const container = document.createElement("div");
        document.body.appendChild(container);
        const instance = new LvMessageBox({
            propsData: {
                title: options.title,
                message: options.message,
                type: options.type,
                confirmText: options.confirmText,
                cancelText: options.cancelText,
                isCancellable: options.isCancellable,
            },
        }).$mount(container);
        const result = await instance.prompt();
        instance.$destroy();
        instance.$el.remove();
        return result;
    }
    MessageBox.prompt = prompt;
})(MessageBox || (MessageBox = {}));
//# sourceMappingURL=index.js.map